// project imports
import { QuestionCategoryDTO } from "../../../common/types/common.dto.types";
import { ActionResponseType } from "../../../common/types/common.types";
import { ApiClient } from "../../../core/api/apiClient.service";
import { MultipleChoicesPageType } from "./MultipleChoicesPage.types";

// ==============================|| VIEWS - PAGES - MULTIPLE CHOICES - API ||============================== //

// client object for axios calls to backend
const client = new ApiClient();

export const getMultipleChoicesList = async (
  searchParameter: QuestionCategoryDTO
): Promise<MultipleChoicesPageType> => {
  try {
    const URL: string = `MultipleChoices/GetMultipleChoicesList`;
    let data = {} as MultipleChoicesPageType;
    await client
      .post<ActionResponseType>(URL, searchParameter)
      .then((response: ActionResponseType) => {
        data.Data = response.Data;
      })
      .catch((error) => {
        data = {} as MultipleChoicesPageType;
      });

    return data;
  } catch (error) {
    throw error;
  }
};
